import React from 'react';

import autoBind from 'react-autobind';
import Autocomplete from '@material-ui/lab/Autocomplete';

// import other components within the same project here
import Localization from "composer/Localization.jsx"

import {
  TextField,
} from '@material-ui/core';

class SchoolList extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasLabel: true,
      selectedOption: null,
      options: [],
      schoolList: [],
      schoolID: -1,
      schoolKey: "",
      inputValue: "",
    };
    autoBind(this);

    if (this.props.hasLabel != null) {
      this.state.hasLabel = this.props.hasLabel;
    }

    this.props.root.refs.API.request("get_school_list", {}, this.getSchoolListOK, this.getSchoolListFailed);
  }

  getSchoolListOK(res) {
    let tmpList = [];
    let schoolList = res.body['result'];
    for (let i = 0; i < schoolList.length; i++) {
      let schoolRow = schoolList[i];
      tmpList.push({
        school_id: schoolRow['id'],
        school_name: schoolRow['name_eng'] + (schoolRow['name'] != schoolRow['name_eng']? " " + schoolRow['name'] : ""),
        school_key: schoolRow['key'],
      });
    }

    let tmpOptions = tmpList.map(school => ({
      value: school.school_id,
      label: school.school_name,
      key: school.school_key,
    }));

    this.setState({
      schoolList: tmpList,
      options: tmpOptions,
    });
    this.state.schoolList = tmpList;
    this.state.options = tmpOptions;
  }

  getSchoolListFailed(err) {
    console.log("get school list failed");
  }

  onSchoolSelected = (event, selectedOption) => {
    this.setState({ selectedOption });
    if (this.props.onSchoolSelected) {
      this.props.onSchoolSelected(selectedOption);
    }
  }

  onInputChanged = (event, value, reason) => {
    this.setState({ inputValue: value });
    this.state.inputValue = value;
  }

  render() {
    return (
      <Autocomplete
        inputValue={this.state.inputValue}
        options={this.state.options}
        getOptionLabel={option => option.label}
        renderInput={params => <TextField {...params} label={this.state.hasLabel? Localization.strings.SCHOOL_LIST : ""} margin="normal" fullWidth style={{width:300, margin:"0px"}} />}
        onChange={this.onSchoolSelected}
        onInputChange={this.onInputChanged}
      />
    )
  }
}

export default SchoolList;
